var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 34V27.2H34V34H28.9V30.6H19.55V34H14.45V30.6H5.1V34H0ZM6.8 23.8C6.31833 23.8 5.91458 23.6371 5.58875 23.3113C5.26292 22.9854 5.1 22.5817 5.1 22.1V1.7C5.1 1.21833 5.26292 0.814583 5.58875 0.48875C5.91458 0.162917 6.31833 0 6.8 0H27.2C27.6817 0 28.0854 0.162917 28.4113 0.48875C28.7371 0.814583 28.9 1.21833 28.9 1.7V22.1C28.9 22.5817 28.7371 22.9854 28.4113 23.3113C28.0854 23.6371 27.6817 23.8 27.2 23.8H6.8ZM8.5 20.4H25.5V3.4H8.5V20.4ZM11.9 10.2H22.1V6.8H11.9V10.2Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPallet);
export default __webpack_public_path__ + "static/media/pallet.cb65dbc057a07d2fcd7612b651ba81f5.svg";
export { ForwardRef as ReactComponent };